module.exports = __webpack_public_path__ + "static/media/kkd-vip-management.f700026c.png";